import { render, staticRenderFns } from "./BannerImageInfo.vue?vue&type=template&id=6465914e&scoped=true&"
import script from "./BannerImageInfo.vue?vue&type=script&lang=js&"
export * from "./BannerImageInfo.vue?vue&type=script&lang=js&"
import style0 from "./BannerImageInfo.vue?vue&type=style&index=0&id=6465914e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6465914e",
  null
  
)

export default component.exports